import { render, staticRenderFns } from "./AdministrasiDashboard.vue?vue&type=template&id=4ff54755&scoped=true"
import script from "./AdministrasiDashboard.vue?vue&type=script&lang=js"
export * from "./AdministrasiDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdministrasiDashboard.vue?vue&type=style&index=0&id=4ff54755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff54755",
  null
  
)

export default component.exports